module.exports = __webpack_public_path__ + "9ab8403dd55be0d61232ba97388c16b2.png";